<template>

  <div>
    <router-link
      :to="{ name: 'PropertyDetails', params: { property_id: property.id }}"
      @click.native="$store.commit('SET_PROPERTY', [])"
    >
      <div class="card moveable-card">
        <div class="card-image">
          <figure class="image is-3by2">
            <img v-bind:src="property.photoUrl">
          </figure>
        </div>
        <div class="card-content">

          <div v-if="property.propertyType == 'Multifamily'">
            <div class="has-text-weight-bold is-size-5">
              {{ property.multifamilyAttributes.propertyName }}
            </div>
            <div class="is-size-6">
              {{ property.address }}
            </div>
            <div class="is-size-6">
              {{ property.city }}, {{ property.state }} {{ property.zip }}
            </div>
          </div>

          <div v-if="property.propertyType == 'Singlefamily'">
            <div class="has-text-weight-bold is-size-5">
              {{ property.multifamilyAttributes.propertyName }}
            </div>
            <div class="has-text-weight-bold is-size-5">
              {{ property.address }}
            </div>
            <div class="is-size-6">
              {{ property.city }}, {{ property.state }} {{ property.zip }}
            </div>
          </div>

          <div v-if="property.propertyType == 'Multifamily'">
            <div class="content"></div>
            <div class="level">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Units</p>
                  <p class="subtitle">&nbsp;{{ property.multifamilyAttributes.units }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Year Built</p>
                  <p class="subtitle">&nbsp;{{ property.multifamilyAttributes.yearBuilt }}&nbsp;</p>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">Class</p>
                  <p class="subtitle">&nbsp;{{ property.multifamilyAttributes.propertyClass }}&nbsp;</p>
                </div>
              </div>
            </div>
          </div>

          <div class="content"></div>
          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Evals</p>
                <p class="subtitle">{{ property.evaluationCount }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Contacts</p>
                <p class="subtitle">{{ property.connectionCount }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Notes</p>
                <p class="subtitle">{{ property.noteCount}} </p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Docs</p>
                <p class="subtitle">{{ property.documentCount }}</p>
              </div>
            </div>
          </nav>
          <nav class="level">
            <div class="level-left is-size-6">
              <span class="icon is-large">
                <i
                  v-bind:class="stageStyle(property.stage)"
                  aria-hidden="true"
                ></i>
              </span>
              {{ property.stage }}
            </div>
            <div class="level-right is-size-7">
              <span>
                <div>{{ property.lastUpdate | dateMedium }}</div>
                <div>{{ property.lastUpdate | fromNow }}</div>
              </span>
            </div>
          </nav>
        </div>
      </div>
    </router-link>
  </div>

</template>

<script>
import Helpers from "@/services/Helpers.js";

export default {
  props: {
    property: {
      type: Object,
      required: true
    }
  },

  methods: {
    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    }
  }
};
</script>

<style>
</style>
